import { useState, useEffect } from 'react';

const osMatchers = {
  macOS: 'mac',
  windows: 'win',
  linux: 'linux',
  unknown: '',
};

export type OS = keyof typeof osMatchers;

export function detectOS(): OS {
  const userAgent = window.navigator.userAgent.toLowerCase();
  const platform = window.navigator.platform.toLowerCase();

  const [os] = Object.entries(osMatchers).find(
    ([, matcher]) => userAgent.includes(matcher) || platform.includes(matcher),
  )!;

  return os as OS;
}

export function useOS() {
  const [os, setOS] = useState<OS>('unknown');

  useEffect(() => {
    setOS(detectOS());
  }, []);

  return os;
}
